import * as React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import { getCommonFieldBasedElementParams, useDatasheetElementController } from "@modules/datasheets/components/result/controllers/datasheet-element";

export type TextFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useTextFieldController = (props: TextFieldProps) => {
  const { datasheetElement, onChange } = props;
  const [textFieldValue, setTextFieldValue] = React.useState(datasheetElement.original.field.fieldname);

  React.useEffect(() => {
    if (textFieldValue !== datasheetElement.original.field.fieldname) {
      setTextFieldValue(datasheetElement.original.field.fieldname);
    }
  }, [datasheetElement.original.field.fieldname]);

  const { 
    headingSizeDependencies, 
    headingPlacedHorizontally, 
    headingPosition 
  } = getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(
    props,
    { headingSizeDependencies }
  );

  const handleTextFieldValueChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setTextFieldValue(e.target.value);
  }, []);

  const handleTextFieldValueSave = React.useCallback(() => {
    onChange(datasheetElement.id, {
      ...datasheetElement,
      original: {
        ...datasheetElement.original,
        field: {
          ...datasheetElement.original.field,
          name: textFieldValue,
        },
      },
    });
  }, [textFieldValue, datasheetElement]);

  return {
    handleTextFieldValueSave,
    handleTextFieldValueChange,
    headingPosition,
    headingPlacedHorizontally,
    textFieldValue,
    ...baseDatasheetElementController,
  };
};